import AOS from 'aos';

AOS.init({
	duration: 1000
});


$(document).ready(function(){
  $('.toggleButton').on('click', function() {
    const card = $(this).closest('.item');
    card.toggleClass('item--open');
  });
});
